import React, { Fragment, useState } from 'react';

// Material UI
import Button from '@mui/material/Button';
import PublishIcon from '@mui/icons-material/Publish';

// Hooks
import useNotify from '../../../hooks/notify';

//Other
import { utils } from '../../../utils/utils';


const InputUpload = ({ id, accept, onChange, hideLegend, text, permittedExtensions, fileLength, ...rest }) => {
    const [filesMessage, setFilesMessage] = useState();
    const { Notify, variants } = useNotify();
    const inputReference = React.createRef();

    const handleChangeInputFile = (event) => {
        setFilesMessage(`Has seleccionado ${event.target.files.length} ficheros`);
        const res = permittedExtensions && fileLength && utils.ValidateFile(event.target.files[0], fileLength, permittedExtensions, accept);
        if(res)
            return Notify(res, variants.ERROR);
        if(onChange) 
            onChange(event);
    };

    const handleClickButton = () => {
        inputReference.current.value = null;
        inputReference.current.click();
    }
    
    return (
        <>
            <input 
                id={id}
                accept={accept} 
                multiple 
                type="file"
                hidden
                onChange={handleChangeInputFile} 
                ref={inputReference}
            />
            <label>
                <Button 
                    variant='contained' 
                    color='primary' 
                    component="span"
                    {...rest}
                    onClick={handleClickButton}
                    startIcon={<PublishIcon />}
                >
                    { text }
                </Button>
                { !hideLegend && <div style={{ marginTop: 8 }}>{filesMessage}</div> }
                <span style={{display: "block"}}>{`Formatos aceptados (${accept.replaceAll('.', ' ')}) ${fileLength ? `y tamaño maximo (${fileLength} Mb)` : ''}`}</span>
            </label>
        </>
    )
}

export default InputUpload;